const formatDollars = (dollars: number): string => {
    return dollars.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
    });
};

export default formatDollars;